import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopProductItemAttributesFragmentDoc } from './shop-product.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopAssociationsWithProductsQueryVariables = Types.Exact<{
  productIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  channelCode: Types.Scalars['String']['input'];
  target: Types.ProductAssociationTarget;
  locale: Types.Scalars['String']['input'];
  regionId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.ShopPageInput>;
  excludeProductIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
  testCases?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  availability?: Types.InputMaybe<Types.ShopProductAvailabilityFilterFlag>;
}>;


export type ShopAssociationsWithProductsQuery = { __typename: 'Query', shopAssociations: Array<{ __typename: 'ShopProductAssociationObject', id: number, title: string, products: Array<{ __typename: 'ShopProductObject', id: number, slug: string, name: string, shortDescription?: string | null | undefined, contentRef?: string | null | undefined, priority: number, variation: Types.ProductVariation, mainTaxonId: number, thumbnailBase64?: string | null | undefined, hidden: boolean, mainTaxon: { __typename: 'ShopTaxonObject', slug: string }, mainMedia?: { __typename: 'ShopProductMediaObject', url: string, type: string, variantId?: number | null | undefined } | null | undefined, secondaryMedia?: { __typename: 'ShopProductMediaObject', url: string, type: string, variantId?: number | null | undefined } | null | undefined, variants: Array<{ __typename: 'ShopProductVariantObject', id: number, slug: string, name: string, description?: string | null | undefined, capAmount?: number | null | undefined, available: boolean, optionValues: Array<{ __typename: 'ShopProductVariantOptionValueObject', optionId: number, id: number }>, price: { __typename: 'ShopCurrencyObject', currency: string, amount: number }, availableRegions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined }>, availability: { __typename: 'ShopProductAvailabilityObject', isAvailable: boolean, minAvailableDate?: string | null | undefined, maxAvailableDate?: string | null | undefined, maxAvailableQuantity?: number | null | undefined, unavailableReason?: Types.ShopProductUnavailableReason | null | undefined, region?: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined } | null | undefined } }>, options: Array<{ __typename: 'ShopProductOptionObject', id: number, name: string, values: Array<{ __typename: 'ShopProductOptionValueObject', id: number, name: string }> }>, taxons: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, badges: Array<{ __typename: 'ShopTaxonBadgeObject', id: number, name: string, badgeIconUrl?: string | null | undefined }>, membershipRequirements: Array<{ __typename: 'ShopMembershipObject', id: number, name: string, activationUrl?: string | null | undefined }>, searchContext: { __typename: 'ShopProductSearchContextObject', objectId: string, queryIndex: string } }> }> };

export type ShopAssociatedProductsQueryVariables = Types.Exact<{
  productIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  associationId: Types.Scalars['Int']['input'];
  channelCode: Types.Scalars['String']['input'];
  locale: Types.Scalars['String']['input'];
  regionId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.ShopPageInput>;
  excludeProductIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
  recommendation?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  availability?: Types.InputMaybe<Types.ShopProductAvailabilityFilterFlag>;
}>;


export type ShopAssociatedProductsQuery = { __typename: 'Query', shopAssociatedProducts: Array<{ __typename: 'ShopProductObject', id: number, slug: string, name: string, shortDescription?: string | null | undefined, contentRef?: string | null | undefined, priority: number, variation: Types.ProductVariation, mainTaxonId: number, thumbnailBase64?: string | null | undefined, hidden: boolean, mainTaxon: { __typename: 'ShopTaxonObject', slug: string }, mainMedia?: { __typename: 'ShopProductMediaObject', url: string, type: string, variantId?: number | null | undefined } | null | undefined, secondaryMedia?: { __typename: 'ShopProductMediaObject', url: string, type: string, variantId?: number | null | undefined } | null | undefined, variants: Array<{ __typename: 'ShopProductVariantObject', id: number, slug: string, name: string, description?: string | null | undefined, capAmount?: number | null | undefined, available: boolean, optionValues: Array<{ __typename: 'ShopProductVariantOptionValueObject', optionId: number, id: number }>, price: { __typename: 'ShopCurrencyObject', currency: string, amount: number }, availableRegions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined }>, availability: { __typename: 'ShopProductAvailabilityObject', isAvailable: boolean, minAvailableDate?: string | null | undefined, maxAvailableDate?: string | null | undefined, maxAvailableQuantity?: number | null | undefined, unavailableReason?: Types.ShopProductUnavailableReason | null | undefined, region?: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined } | null | undefined } }>, options: Array<{ __typename: 'ShopProductOptionObject', id: number, name: string, values: Array<{ __typename: 'ShopProductOptionValueObject', id: number, name: string }> }>, taxons: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, badges: Array<{ __typename: 'ShopTaxonBadgeObject', id: number, name: string, badgeIconUrl?: string | null | undefined }>, membershipRequirements: Array<{ __typename: 'ShopMembershipObject', id: number, name: string, activationUrl?: string | null | undefined }>, searchContext: { __typename: 'ShopProductSearchContextObject', objectId: string, queryIndex: string } }> };

export type ShopAssociationsQueryVariables = Types.Exact<{
  productIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  channelCode: Types.Scalars['String']['input'];
  target: Types.ProductAssociationTarget;
  locale: Types.Scalars['String']['input'];
  testCases?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type ShopAssociationsQuery = { __typename: 'Query', shopAssociations: Array<{ __typename: 'ShopProductAssociationObject', id: number, title: string }> };

export const ShopAssociationsWithProductsDocument = gql`
    query ShopAssociationsWithProducts($productIds: [Int!]!, $channelCode: String!, $target: ProductAssociationTarget!, $locale: String!, $regionId: Int, $page: ShopPageInput, $excludeProductIds: [Int!], $testCases: [String!], $availability: ShopProductAvailabilityFilterFlag) {
  shopAssociations(
    productIds: $productIds
    channelCode: $channelCode
    target: $target
    locale: $locale
    testCases: $testCases
  ) {
    id
    title
    products(
      productIds: $productIds
      channelCode: $channelCode
      locale: $locale
      regionId: $regionId
      page: $page
      excludeProductIds: $excludeProductIds
      availability: $availability
    ) {
      ...ShopProductItemAttributes
    }
  }
}
    ${ShopProductItemAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopAssociationsWithProductsGQL extends Apollo.Query<ShopAssociationsWithProductsQuery, ShopAssociationsWithProductsQueryVariables> {
    document = ShopAssociationsWithProductsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopAssociatedProductsDocument = gql`
    query ShopAssociatedProducts($productIds: [Int!]!, $associationId: Int!, $channelCode: String!, $locale: String!, $regionId: Int, $page: ShopPageInput, $excludeProductIds: [Int!], $recommendation: Boolean, $availability: ShopProductAvailabilityFilterFlag) {
  shopAssociatedProducts(
    productIds: $productIds
    associationId: $associationId
    channelCode: $channelCode
    locale: $locale
    regionId: $regionId
    page: $page
    excludeProductIds: $excludeProductIds
    recommendation: $recommendation
    availability: $availability
  ) {
    ...ShopProductItemAttributes
  }
}
    ${ShopProductItemAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopAssociatedProductsGQL extends Apollo.Query<ShopAssociatedProductsQuery, ShopAssociatedProductsQueryVariables> {
    document = ShopAssociatedProductsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopAssociationsDocument = gql`
    query ShopAssociations($productIds: [Int!]!, $channelCode: String!, $target: ProductAssociationTarget!, $locale: String!, $testCases: [String!]) {
  shopAssociations(
    productIds: $productIds
    channelCode: $channelCode
    target: $target
    locale: $locale
    testCases: $testCases
  ) {
    id
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopAssociationsGQL extends Apollo.Query<ShopAssociationsQuery, ShopAssociationsQueryVariables> {
    document = ShopAssociationsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }